import React from "react"

import {
  HeadingInitial,
  HeadingSecondary,
  Section,
  List,
  ListItem,
  Tagline,
} from "elements"

const registration = props =>
  <div>
    <HeadingInitial>Registration Help</HeadingInitial>

    <Tagline>
      The history of Camps and Campers begins with the 1996 launch of Campstaff
      by camp professionals Chris “Bunkie” Roy and Eric Sasson.
    </Tagline>

    <Section>
      <HeadingSecondary>Registration for Camp Families</HeadingSecondary>

      <List>
        <ListItem>
          You will be asked to submit your name and some basic information about
          your contact, camp interests, and camper (no names). This allows camps
          to find you and contact you about camp openings that they have.
        </ListItem>
        <ListItem>
          The only people who will ever have access to your information are
          legitimate summer camps who have registered with us.
        </ListItem>
        <ListItem>
          There is never any cost to you for using Camps and Campers, regardless
          of how much you use it.
        </ListItem>
        <ListItem>
          You will receive periodic emails announcing new camps and specific
          camp opportunities.
        </ListItem>
        <ListItem>
          You can remove yourself from our database at any time.
        </ListItem>
      </List>

      <HeadingSecondary>Registration for Camps</HeadingSecondary>

      <List>
        <ListItem>
          If you are a returning camp from last year, log in at the top of the
          page now and have last year’s information filled in automatically. All
          you’ll have to do is make some simple updates to your openings and
          your start and end dates.
        </ListItem>
        <ListItem>
          For new camps, you will be asked to submit your name and some basic
          information about your camp and what type of campers you are looking
          for.
        </ListItem>
        <ListItem>
          New camps will be asked to select a membership package. See our
          pricing for more details.
        </ListItem>
        <ListItem>
          You will be notified shortly after registration when your profile is
          active and your camp information is made available to camp families.
        </ListItem>
      </List>
    </Section>
  </div>

export default registration



// WEBPACK FOOTER //
// ./src/scenes/Help/pages/registration.js